import { render, staticRenderFns } from "./multi-account.vue?vue&type=template&id=60b76b30"
import script from "./multi-account.vue?vue&type=script&lang=js"
export * from "./multi-account.vue?vue&type=script&lang=js"
import style0 from "./multi-account.vue?vue&type=style&index=0&id=60b76b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports